import * as React from "react";
import { connect } from "react-redux";
import VisitThrive from "./VisitThrive";
import StartThrive from "./StartThrive";
import MyChartActivation from "./MyChartActivation";
import NotAuthorized from "../common/NotAuthorized";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

/**
 * Container component for the Thrive page.
 * 
 */
class Thrive extends React.Component {

    componentDidMount() {
        logUI("MBHWeb.UI.Thrive.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const thrive = this.props.thrive;
        if (!thrive) {
            return null;
        }
        return (
            <React.Fragment>
                {thrive.canVisitThrive ?
                    (<div className="container-fluid body-content" id="thrive-landing">
                        <div className="row">
                            <div className="col-12 maxWidth-content">

                                <div className="row thrive-logo-container">
                                    <div className="col-12 text-center">
                                        <img className="img-fluid" alt="Thrive logo" src="/images/thrive-logo-color.png" />
                                    </div>
                                </div>

                                <div className="row row-card-eq">
                                    <div className="col-12">
                                        <VisitThrive employeeLoggedIn={thrive.employeeLoggedIn} thriveMainUrl={thrive.thriveMainUrl} />
                                    </div>
                                    {/*<div className="col-12 col-lg-6">
                                        {thrive.hasMyChart ?
                                            <StartThrive thriveGetStartedUrl={thrive.thriveGetStartedUrl} /> :
                                            <MyChartActivation myChartLinkUrl={thrive.myChartLinkUrl} myChartActivationUrl={thrive.myChartActivationUrl} />
                                        }
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>) :
                    <NotAuthorized />
                }
            </React.Fragment>
            
        );
    }
}

const mapStateToProps = (state) => {
    return {
        thrive: state.header.thrive
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Thrive);